/* eslint-disable */
import React from 'react';
import { Container } from '@mui/material';
import { useOutletContext } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import PeopleIcon from '@mui/icons-material/People';

import PairedUsersMessaging from '../../components/pairedUsers/PairedUsersMessaging';

const YourEdifiers = () => {
  const pairedUsers = useOutletContext();
  const isLoading = pairedUsers[5];
  const pairedList = pairedUsers[6]?.data?.data || [];

  return (
    <Container
      maxWidth="xl"
      sx={{
        p: '0 !important',
        flex: 1,
        minHeight: 0,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Helmet>
        <title>Edifying Teachers | Edifiers</title>
      </Helmet>

      <PairedUsersMessaging
        pairedUsersList={pairedList}
        isLoading={isLoading}
        pageTitle="Paired Edifiers"
        emptyIcon={PeopleIcon}
        emptyTitle="No Paired Edifiers Yet"
        emptyDescription="Once you're paired with an edifier, they'll appear here for easy access."
        onlyPairedAndAdmin
      />
    </Container>
  );
};

export default YourEdifiers;
